import { MetaByPath } from "../config";

export const buildPartnerMetaByPath = (
  pathname: string,
  partnerPatternMetaByPath: MetaByPath,
) => {
  const slug = pathname.split("/")[2];
  const keys = Object.keys(partnerPatternMetaByPath);
  const values = Object.values(partnerPatternMetaByPath);

  const newKeys = keys.map((key) => {
    return key.replace(":slug", slug);
  }) as string[];

  const newMetaByPath = newKeys.reduce((acc, key, index) => {
    acc[key] = values[index];
    return acc;
  }, {} as MetaByPath);

  return newMetaByPath;
};
